import { render, staticRenderFns } from "./DisplayField.vue?vue&type=template&id=58509c2e&scoped=true"
import script from "./DisplayField.vue?vue&type=script&lang=js"
export * from "./DisplayField.vue?vue&type=script&lang=js"
import style0 from "./DisplayField.vue?vue&type=style&index=0&id=58509c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58509c2e",
  null
  
)

export default component.exports